/* unplugin-vue-components disabled */import script from "./UserKeyword.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserKeyword.vue?vue&type=script&lang=ts&setup=true"

import "./UserKeyword.vue?vue&type=style&index=0&id=083dc70d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083dc70d"]])

export default __exports__